import {NgModule} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';

import { PecEnAttenteListeFeatureComponent } from './pec-en-attente-liste.feature.component';
import {ModaleRessaisirFactureFeatureModule} from "@app/fonctionnalites/factures/prise-en-charge/modale-ressaisir-facture-liste/modale-ressaisir-facture.feature.module";
import {SelectGarantModule} from "@app/fonctionnalites/factures/select-garant/select-garant.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        ModaleRessaisirFactureFeatureModule,
        SelectGarantModule,
    ],
  exports: [PecEnAttenteListeFeatureComponent],
  declarations: [PecEnAttenteListeFeatureComponent],
  providers: [],
})
export class PecEnAttenteListeFeatureModule {
}
